export default {
      id: "ic_fleche_droite-usage",
      viewBox: "0 0 50 50",
      url: "../dist/images/" + "sprite.svg#ic_fleche_droite-usage",
      toString: function () {
        return this.url;
      }
    }